/**
 * Error/Validation Messages
 */

export enum Constants {
  FAILED_ADD_PARTNER = 'Unable to add partner, please try again or contact customer support',
  SUCCESS_ADD_PARTNER = 'Successfully associated the Partner account',

  FAILED_PUBLISH_HOLDER = 'Unable to save, please try again or contact customer support',
  SUCCESS_PUBLISH_HOLDER = 'You have been added to the Waiting list.',

  FAILED_GET_HOLDER = 'Problem fetching holder account',
  SUCCESS_GET_HOLDER = 'Successfully fetched account',

  FORM_ERROR = 'Please make sure to fill all the required fields',

  GENERAL_ERROR = 'Encountered a problem',
  GENERAL_SUCCESS = 'Operation completed successfully',
}
